'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (element) {
  if (element !== null) {

    var updateVideoDimensions = function updateVideoDimensions() {
      var videoParent = element.parentNode,
          computedStylesOfParent = window.getComputedStyle(videoParent, null),
          widthIncludingPadding = videoParent.clientWidth,
          padding = parseFloat(computedStylesOfParent.paddingRight) + parseFloat(computedStylesOfParent.paddingLeft),
          videoParentWidth = widthIncludingPadding - padding;

      if (videoParentWidth < 800) {
        element.style.width = videoParentWidth + 'px';
        element.style.height = videoParentWidth * 0.562 + 'px';
      } else {
        element.style.width = '800px';
        element.style.height = 800 * 0.562 + 'px';
      }
    };

    updateVideoDimensions();
    window.addEventListener('resize', (0, _debounce2.default)(updateVideoDimensions, 300));
  }
};

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }